import NewButton from 'CMFW/button/NewButton';
import ReloadButton from 'CMFW/button/ReloadButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import ItemLayout from 'CMFW/layout/ItemLayout';
import { LoadingItem } from 'CMFW/layout/Loading';
import { ContainerLeft, ContainerLeftFooter, ContainerRight, ModuleContainer } from 'components/common/styles';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import Note from 'modules/Note/Note';
import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { ItemTabs } from '../../CMFW/layout/ItemTabs';
import TextSearch from '../../components/search/TextSearch';
import BookEdit from './tabs/BookEdit';
import BookChapter from './tabs/BookChapter';
import BookModel from '../../models/BookModel';
import { IFields } from '../../CMFW/grid/fields';
import { illustrationRenderer } from '../../CMFW/grid/cellRenderers/illustration';
import { INavigationStep } from 'types/navigation';
import { IRefIds } from 'constants/refs';

export type IProps = {
  courseId: number;
  search?: string;
  navigationPath?: INavigationStep[];
};

const Book: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();
  const [showTabIndex, setShowTabIndex] = useState<number | undefined>();
  const [childNavigationPath, setChildNavigationPath] = useState<INavigationStep[]>([]);

  const bookModel = useMemo(
    () => new BookModel({ render: forceRender, courseId: props.courseId, search: props.search }),
    [forceRender, props.courseId, props.search],
  );

  // Process navigation path
  useEffect(() => {
    if (props.navigationPath && props.navigationPath.length > 0) {
      const firstStep = props.navigationPath[0];

      if (firstStep.ref === IRefIds.bookChapter || firstStep.ref === IRefIds.bookChapterText) {
        // Switch to Chapters tab (index 0 when book is selected)
        setShowTabIndex(0);

        // Pass the entire navigation path to BookChapter
        setChildNavigationPath(props.navigationPath);
      }
    }
  }, [props.navigationPath]);

  // Reset child navigation when clicking book grid
  const resetChildNavigation = useCallback(() => {
    setChildNavigationPath([]);
  }, []);

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={bookModel}>
        <Split widthLeft={300}>
          <ContainerLeft>
            <TextSearch />
            <Grid
              cellRenderers={{
                [IFields.illustration]: illustrationRenderer,
              }}
              onRowClick={resetChildNavigation}
            />
            <ContainerLeftFooter>
              <ReloadButton />
              <NewButton />
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            <ItemLayout>
              <ItemTabs
                tabNames={[bookModel.itemId > 0 ? 'Chapters' : undefined, 'Edit'].filter(Boolean) as string[]}
                showTabIndex={showTabIndex}
              >
                {bookModel.itemId > 0 && (
                  <BookChapter key={'Texts' + bookModel.itemId} navigationPath={childNavigationPath} />
                )}
                <BookEdit key={'Edit' + bookModel.itemId} />
              </ItemTabs>
            </ItemLayout>
            <Note />
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default Book;
